import {ConfigUserRestControllerApiFactory, User} from "arteco-api-client-ts";
import AppList, {AppListConfig} from "../../../../components/layout/list";
import {PersonAvatar} from "../../../../components/kit";
import {Stack, Typography} from "@mui/material";
import {TableCell} from "@mui/material";
import {useApiManager} from "../../../../components/utils/api";
import {COLOR_DISMISSED} from "../../../../components/layout/colors";

export const UserListPage = () => {
	const apiManager = useApiManager();

	const listConfig: AppListConfig<User> = {
		title: "Usuarios ",
		onClick: "/app/admin/config/user",
		headers: [
			{title: "Usuario"},
			{title: "Email"},
		],
		decorator: (bean: User) => (
			<  >
				<TableCell style={{color: bean.dismissed ? COLOR_DISMISSED : ""}}>
					<Stack direction="row" spacing={1.5} alignItems="center" sx={{minWidth: 0}}>
						<PersonAvatar name={bean.username} size={30}/>
						<Typography variant="body2" fontWeight={600} noWrap>{bean.username}</Typography>
					</Stack>
				</TableCell>
				<TableCell>
					{bean.email}
				</TableCell>
			</>
		),
		supplier: async (currentPage, size, term, showDismissed) => {
			const ctrl = apiManager.factory(ConfigUserRestControllerApiFactory);
			return ctrl.pageUser(currentPage, size, undefined, term, showDismissed);
		},
	};

	return (
		<>
			<AppList config={listConfig}/>
		</>
	);
};